export const LKQ_PRICING_WILDCARD = '*';
export const LKQ_PRICING_ALL_LABEL = 'All';

export function formatLkqPricingDimensionLabel(
    id: string | undefined,
    displayName: string | undefined,
    unknownLabel: string,
): string {
    if (id === LKQ_PRICING_WILDCARD) return LKQ_PRICING_ALL_LABEL;
    return displayName ?? id ?? unknownLabel;
}

export function formatLkqPricingStateLabel(state: string): string {
    return state === LKQ_PRICING_WILDCARD ? LKQ_PRICING_ALL_LABEL : state;
}

/** "All" first, then alphabetical — the order a states cell reads in. */
export function sortLkqPricingStates(states: string[]): string[] {
    return Array.from(new Set(states)).sort((a, b) => {
        if (a === LKQ_PRICING_WILDCARD) return -1;
        if (b === LKQ_PRICING_WILDCARD) return 1;
        return a.localeCompare(b);
    });
}

/** "All", or the state codes a row covers; an em dash when it covers none. */
export function formatLkqPricingStatesLabel(states: string[]): string {
    if (states.length === 0) return '—';
    return states.map(formatLkqPricingStateLabel).join(', ');
}
